<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Specialties List</h1>
        </div>
        <div class="col-sm-6 float-left add_user_btn">
            <a routerLink="/create-specialties" class="btn btn-success" *ngIf="myrole=='1' || myrole=='6'">
                <i class="fa fa-plus" aria-hidden="true"></i> Add Specialties
            </a>
        </div>

    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text"
                            (keyup)="loadSpecialtiesList(0,perpage)" placeholder="Search" /></div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadSpecialtiesList(0,perpage)"><i class="fa fa-sync"
                            [ngClass]="{'fa-spin':loading}"></i> Refresh List</button></div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th>Name</th>
                            <th>Show in Glamyo Health</th>
                            <th>Show in Glamyo Dental</th>
                            <th>Image</th>
                            <th>Status</th>
                            <th style="width: 100px;">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let specialties of SpecialtiesList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{specialties.name}}</td>
                            <td>
                                <span *ngIf="specialties.show_in_glamyo_health=='1'">Yes</span>
                                <span *ngIf="specialties.show_in_glamyo_health=='0'">No</span>
                            </td>
                            <td>
                                <span *ngIf="specialties.show_in_glamyo_dental=='1'">Yes</span>
                                <span *ngIf="specialties.show_in_glamyo_dental=='0'">No</span>
                            </td>
                            <td>
                                <img class="profile_pic" *ngIf="specialties.image_icon; else noImage"
                                    alt="specialtiesImage" src="{{sc3Url}}{{specialties.image_icon}}">
                                <ng-template #noImage>-</ng-template>
                            </td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="specialties.status=='1'">Active</span>
                                <span class="badge bg-azure-light" *ngIf="specialties.status=='0'">In-Active</span>
                            </td>
                            <td>
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        id="{{specialties.id}}" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        Action
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="{{specialties.id}}">
                                        <a class="dropdown-item" routerLink="/update-specialties/{{specialties.id}}"><i
                                                class="fa fa-pen"></i> Update</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !SpecialtiesList.length">
                            <td colspan="20"><i class="far fa-frown"></i> Specialties not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>
</div>